export default __webpack_public_path__ + "static/media/updated_josa.820c8cfd.svg";